export class CustomDialog extends HTMLElement {
  #state = {
    open: true
  };

  timeout = null;

  duration = 150;

  connectedCallback() {
    this.init();
  }

  init() {
    this.initState();
    this.closeButtons?.forEach(button => {
      button?.addEventListener('click', this.handleToggleEvent.bind(this));
    });
    this.dialog?.addEventListener('click', this.handleDialogClickEvent.bind(this));
  }

  initState() {
    if (this.hasAttribute('open')) {
      this.dialog.setAttribute('open', 'true');
      this.#state.open = true;
    } else {
      this.dialog.removeAttribute('open');
      this.#state.open = false;
    }
  }

  handleToggleEvent() {
    if (this.#state.open) {
      this.close();
    } else {
      this.open();
    }
  }

  handleDialogClickEvent(e) {
    const { target } = e;
    if (this.dialog === target) {
      this.close();
      return;
    }
    if (this.dialog.contains(target)) return;
    this.close();
  }

  open() {
    this.setAttribute('open', 'true');
    this.timeout = setTimeout(() => {
      this.dialog.setAttribute('open', 'true');
    }, this.duration);
    this.#state.open = true;
  }

  close() {
    this.dialog.removeAttribute('open', 'true');
    this.timeout = setTimeout(() => {
      this.removeAttribute('open', 'true');
    }, this.duration);
    this.#state.open = false;
  }

  get dialog() {
    return this.querySelector('[ref="dialog"]');
  }

  get closeButtons() {
    return this.querySelectorAll('[ref="closeButton"]');
  }
}

if (!customElements.get('custom-dialog')) {
  customElements.define('custom-dialog', CustomDialog);
}